import { mapGetters } from 'vuex';

export const RouteAPI = {
  computed: {
    ...mapGetters('app', ['appConfig']),
  },
  methods: {
    routeAPILogin() {
      return this.appConfig.baseUrl + '/api/auth/login';
    },
    routeAPIGetUserInfo() {
      return this.appConfig.baseUrl + '/api/user';
    },
    routeAPILogout() {
      return this.appConfig.baseUrl + '/api/auth/logout';
    },
    routeAPIRegister() {
      return this.appConfig.baseUrl + '/api/register';
    },
    routeAPIGetNotifications() {
      return this.appConfig.baseUrl + '/api/notifications';
    },
    routeAPIRemoveNotification() {
      return this.appConfig.baseUrl + '/notification/remove-notification-feature';
    },
    routeAPIGetRewardsFromAward() {
      return this.appConfig.baseUrl + '/api/user/get-rewards-from-award';
    },
    routeAPISetUserzone() {
      return this.appConfig.baseUrl + '/set_userzone';
    },
    routeAPICheckUserUpdateEmail() {
      return this.appConfig.baseUrl + '/api/check-user-update-email';
    },
    routeAPIClearImportUserSession() {
      return this.appConfig.baseUrl + '/api/clear-import-user-session';
    },
    routeAPICheckUserExisted() {
      return this.appConfig.baseUrl + '/api/check-user-existed';
    },
    routeAPICheckConnectPlatformData() {
      return this.appConfig.baseUrl + '/api/get-connect-platform-data';
    },
    routeAPIGetAdminSchoolHub() {
      return this.appConfig.baseUrl + '/api/get-admin-school-hub';
    },
    routeAPIUpdateEmailTwitter() {
      return this.appConfig.baseUrl + '/api/update-email-twitter';
    },
    routeAPISetNotificationViewed() {
      return this.appConfig.baseUrl + '/notification/send-to-viewed';
    },
    routeAPIHubInfo() {
      return this.appConfig.baseUrl + '/about-hub';
    },
    routeAPISubmitGameName() {
      return this.appConfig.baseUrl + '/subshowdown/submitGameName';
    },
    routeCreateDiscordChannel() {
      return this.appConfig.baseUrl + '/create_administrator_discord_channel';
    },
    routeDrops() {
      return this.appConfig.baseUrl + '/drops';
    },
    routeAPIGetListMemberHub() {
      return this.appConfig.baseUrl + '/api/get-list-hub-member';
    },
    routeAPIGetQueueupActiveGames() {
      return this.appConfig.baseUrl + '/api/get-queueup-active-games';
    },
    routeAPIGetMyHub() {
      return this.appConfig.baseUrl + '/api/get-my-hub';
    },
    routeAPIGetPersonalEventsUrl() {
      return this.appConfig.baseUrl + '/api/get-personal-events-url';
    },
  },
};
